import React from 'react';
import type { EditionType } from '../../../../shared/types/index.js';

export interface EditionTypeOption {
  value: EditionType;
  label: string;
  desc: string;
}

export const editionTypes: EditionTypeOption[] = [
  {
    value: 'revisi',
    label: 'Edisi Revisi',
    desc: 'Pembaruan materi, koreksi, dan penambahan bab substansial.',
  },
  {
    value: 'digital',
    label: 'Edisi Digital (E-Book)',
    desc: 'Format digital interaktif / EPUB / PDF untuk pembaca elektronik.',
  },
  {
    value: 'cetakan_baru',
    label: 'Cetakan Ulang / Baru',
    desc: 'Pencetakan ulang berkala dengan perbaikan tipografi minor.',
  },
  {
    value: 'terjemahan',
    label: 'Edisi Terjemahan',
    desc: 'Alih bahasa asing atau daerah untuk perluasan jangkauan.',
  },
  {
    value: 'edisi_khusus',
    label: 'Edisi Khusus / Kolektor',
    desc: 'Edisi sampul keras (hardcover), ilustrasi eksklusif, bonus konten.',
  },
  {
    value: 'edisi_saku',
    label: 'Edisi Saku (Paperback)',
    desc: 'Ukuran saku praktis dan harga terjangkau.',
  },
];

interface EditionTypeGridProps {
  selectedType: EditionType;
  onSelectType: (type: EditionType) => void;
}

export const EditionTypeGrid: React.FC<EditionTypeGridProps> = ({
  selectedType,
  onSelectType,
}) => {
  return (
    <div>
      <label className="block text-xs font-bold text-slate-700 mb-1.5">
        Tipe Edisi / Format Turunan <span className="text-rose-500">*</span>
      </label>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {editionTypes.map((t) => (
          <button
            key={t.value}
            type="button"
            onClick={() => onSelectType(t.value)}
            className={`p-2.5 rounded-xl border text-left transition flex flex-col justify-between cursor-pointer ${
              selectedType === t.value
                ? 'bg-indigo-50/80 border-indigo-500 text-indigo-900 ring-2 ring-indigo-400/40'
                : 'bg-slate-50 border-slate-200 hover:border-slate-300 text-slate-700'
            }`}
          >
            <span className="text-xs font-bold">{t.label}</span>
            <span className="text-[10px] text-slate-500 line-clamp-2 mt-0.5">
              {t.desc}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
